<template>
  <el-select
    v-model="input"
    :remote-method="querySearch"
    placeholder="Enter name of Carrier"
    multiple
    filterable
    remote
    class="w-100"
    size="small"
    clearable
    :disabled="disabled"
    :loading="isLoading"
    @clear="clearInput"
  >
    <el-option
      v-for="item in data"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      input: '',
      data: [],
      isLoading: false
    }
  },
  created () {
    if (this.value.id) {
      this.input = this.value.name
    }
  },
  methods: {
    querySearch (queryString, cb) {
      this.isLoading = true
      this.$sdk.carrier.list(builder => {
        builder.filters = { 'carrier_name': queryString }
      }).then(res => {
        this.data = res
        this.isLoading = false
      })
    },
    getCarrierId () {
      return this.input
    },
    clearInput () {
      this.input = ''
      this.$emit('input', {})
    }
  }
}
</script>

<style>

</style>
